<section [class]="[(isValid ? 'ready' : 'attention'), 'display-flex']">
    <mat-icon [color]="'NEW' == appId ? 'primary' : 'warn'">{{(isValid && 'NEW' == appId ? 'thumb_up' :
        'error')}}</mat-icon>
    <h2 [class]="['mat-headline-3']">{{ !isValid ? statusText : ('NEW' == appId ? 'Application can be submitted' :
        'Encountered an unexpected error')}}</h2>

    @for ( currentStep of props.dataModel; track currentStep.step ) {
    @if ( currentStep?.invalidValues?.length > 0 ) {
    <div
        [class]="{'flex-full' : true,'mutara-strong' : true, 'mutara-hide' : (currentStep.invalidValues?.length ?? 0) == 0}">
        {{currentStep.label}}
        <span class="sr-only">{{currentStep.label}}, contains errors</span>
    </div>
    }
    @for (fldDefn of currentStep.invalidValues; track fldDefn.key ) {
    @if (!fldDefn.hide) {
    <button mat-flat-button class="mutara-sm-strong" color="warn" type="button"
        (click)='setFocus(fldDefn)'>{{fldDefn.props.currentError}}<span class="sr-only">, click to make
            corrections</span>
        <!-- mat-icon aria-hidden="true">edit_square</mat-icon -->
    </button>
    }
    }
    }
</section>